import React, { useState } from "react";
import BackButton from "./BackButton";
import { useDispatch } from "react-redux";
import { msgAccessPromt } from "../../constant/constant";
import { login_user, signup_user } from "../../features/userSlice";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const MpinForm = () => {
    const [mpin, setMpin] = useState(["", "", "", ""]);
    const [confirmMpin, setConfirmMpin] = useState(["", "", "", ""]);
    const dispatch=useDispatch();
    const handleInputChange = (index, value, type) => {
        if (!/^\d*$/.test(value)) return; // Restrict to digits only

        const updatedValues = type === "mpin" ? [...mpin] : [...confirmMpin];
        if(updatedValues[index]==='' || value===''){
            updatedValues[index] = value;
        if (type === "mpin") {
            setMpin(updatedValues);
        } else {
            setConfirmMpin(updatedValues);
        }
    }
        // Automatically move to the next input
        if (value && index < 5) {
            const nextInput = document.getElementById(`${type}-${index + 1}`);
            if (nextInput) nextInput.focus();
        }
    };
    const handleSubmit = async (e) =>  {
        e.preventDefault();
         msgAccessPromt({dispatch,msg:'LOADING',error:true});
        if (JSON.stringify(mpin) === JSON.stringify(confirmMpin)) {
             let val='';
                    if(!(mpin[0] && mpin[1] && mpin[2] && mpin[3]))
                    {
                    msgAccessPromt({dispatch,error:true,msg:'Only 4 digit allow !!'});
                    return false;
                    }else{
                        val=mpin.reduce((acc, num) => parseInt(acc + num), 0);;
                    }
          var form_data_new = new FormData();
          let phone_number=localStorage.getItem('phone_number');
          let user_email=localStorage.getItem('user_email');
          let user_name=localStorage.getItem('user_name');
          let user_token=localStorage.getItem('user_token');

          form_data_new.append('phoneNumber',phone_number);
          form_data_new.append('username',user_name);
          form_data_new.append('token_id',user_token);
          form_data_new.append('user_mpin',val);
          form_data_new.append('email',user_email);
          
            let ApiCall=   dispatch(signup_user(form_data_new));    
            
            if(ApiCall){
            setTimeout(()=>{
              let data = new FormData();
              data.append('phone_number',phone_number);
              data.append('password',val);
              data.append('token_id',user_token);
               dispatch(login_user(data));
            },2000)
            }
         
        }else{
            msgAccessPromt({dispatch,error:true,msg:'Mpin does not match with confirm Mpin.'});
        }
      };
 

    return (
        <div className="bodyDiv">
        <div className="mpin-container">
            <BackButton></BackButton>
            <div style={{marginTop:'27%'}}>
            <div className="title_Form" style={{justifyContent:'space-between'}}>
                <div className="title_left">
                    <h1 className="main_title">MPIN</h1>
                    <p>Create MPIN for login</p>
                    </div>
                    <div className="title_right">
                        <FontAwesomeIcon icon={faLock} color="#007bff" size="3x" padding='3%' />
                        
                    </div>
            </div>
            <div className="input-group">
                <label>Enter MPIN</label>
                <div className="mpin-input">
                    {mpin.map((value, index) => (
                        <input
                            key={index}
                            id={`mpin-${index}`}
                            type="number"
                            className="input_lable_deep"
                            maxLength="1"
                            value={value}
                            onChange={(e) => handleInputChange(index, e.target.value, "mpin")}
                        />
                    ))}
                </div>
            </div>
            <div className="input-group">
                <label>Confirm MPIN</label>
                <div className="mpin-input">
                    {confirmMpin.map((value, index) => (
                        <input
                            key={index}
                            id={`confirmMpin-${index}`}
                            type="number"
                            className="input_lable_deep"
                            maxLength="1"
                            value={value}
                            onChange={(e) => handleInputChange(index, e.target.value, "confirmMpin")}
                        />
                    ))}
                </div>
            </div>
            <button className="generate-mpin-button" onClick={handleSubmit}>GENERATE MPIN</button>
        </div>
        </div>
        </div>
    );
};

export default MpinForm;
